import {TransactionsApi} from "@/services/api/TransactionsApi";
import {ContributionNotificationTemplateApi, NotificationTemplateApi} from "@/services/api/NotificationTemplateApi";

export class VehicleTransactionsApi extends TransactionsApi {
    public relativeUri: string = "vehicle-transactions";

    public notificationTemplate = new NotificationTemplateApi(this);
    public contributionNotificationTemplate = new ContributionNotificationTemplateApi(this);
}
